"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCouponStore = void 0;
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
exports.useCouponStore = (0, pinia_1.defineStore)('couponStore', {
    state: () => ({
        coupons: [],
        loading: false,
        totalCoupons: 0,
        customerCoupons: [],
    }),
    getters: {
        activeCustomerCoupons: (state) => {
            return state.customerCoupons.filter((coupon) => {
                return !coupon.archived;
            });
        },
        archivedCustomerCoupons: (state) => {
            return state.customerCoupons.filter((coupon) => {
                return coupon.archived;
            });
        }
    },
    actions: {
        getCoupons(router, params = {}) {
            this.loading = true;
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: 'admin_coupons_api', query: params }).href)
                    .then((response) => {
                    var _a;
                    let coupons = [];
                    if (Array.isArray(response['hydra:member'])) {
                        response['hydra:member'].forEach(element => {
                            if (element['@type'] !== 'Coupon') {
                                return;
                            }
                            coupons.push(element);
                        });
                    }
                    this.coupons = coupons;
                    this.totalCoupons = (_a = response['hydra:totalItems']) !== null && _a !== void 0 ? _a : 0;
                    this.loading = false;
                    resolve(response);
                })
                    .catch(error => {
                    this.loading = false;
                    reject(error);
                });
            });
        },
        getCustomerCoupons(router) {
            this.loading = true;
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: 'admin_customer_coupons_api' }).href)
                    .then((response) => {
                    let coupons = [];
                    if (Array.isArray(response['hydra:member'])) {
                        response['hydra:member'].forEach(element => {
                            if (element['@type'] !== 'Coupon') {
                                return;
                            }
                            coupons.push(element);
                        });
                    }
                    this.customerCoupons = coupons;
                    this.loading = false;
                    resolve(response);
                })
                    .catch(error => {
                    this.loading = false;
                    reject(error);
                });
            });
        },
        getCouponsBySite(router, params = {}) {
            this.loading = true;
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: 'admin_site_coupons_api', query: params }).href)
                    .then((response) => {
                    var _a;
                    let coupons = [];
                    if (Array.isArray(response['hydra:member'])) {
                        response['hydra:member'].forEach(element => {
                            if (element['@type'] !== 'Coupon') {
                                return;
                            }
                            coupons.push(element);
                        });
                    }
                    this.coupons = coupons;
                    this.totalCoupons = (_a = response['hydra:totalItems']) !== null && _a !== void 0 ? _a : 0;
                    this.loading = false;
                    resolve(response);
                })
                    .catch(error => {
                    this.loading = false;
                    reject(error);
                });
            });
        },
        deleteCoupon(router, couponId) {
            this.loading = true;
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({
                    name: 'admin_coupons_api',
                    params: {
                        id: couponId
                    }
                }).href, { method: 'DELETE' })
                    .then(response => {
                    this.loading = false;
                    resolve();
                })
                    .catch(error => {
                    this.loading = false;
                    reject(error);
                });
            });
        },
        createCoupon(router, couponRequest) {
            this.loading = true;
            let options = { body: JSON.stringify(couponRequest), method: 'POST' };
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: 'admin_coupons_api' }).href, options).then(response => {
                    this.loading = false;
                    resolve(response);
                }).catch(error => {
                    this.loading = false;
                    reject(error);
                });
            });
        },
        updateCoupon(router, couponRequest, couponId) {
            this.loading = true;
            let options = { body: JSON.stringify(couponRequest), method: 'PUT' };
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: 'admin_coupons_api', params: { id: couponId } }).href, options).then(response => {
                    this.loading = false;
                    resolve(response);
                }).catch(error => {
                    this.loading = false;
                    reject(error);
                });
            });
        },
        updateCouponRemainValue(router, remainValue, couponId) {
            this.loading = true;
            let options = { body: JSON.stringify({ remainValue: remainValue }), method: 'PATCH' };
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: 'admin_coupons_api', params: { id: couponId } }).href, options).then(response => {
                    this.loading = false;
                    resolve(response);
                }).catch(error => {
                    this.loading = false;
                    reject(error);
                });
            });
        },
        uploadCouponCsv(router, formData) {
            this.loading = true;
            let options = {
                method: 'POST',
                body: formData
            };
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: 'admin_upload_coupons_csv_api' }).href, options).then(response => {
                    this.loading = false;
                    resolve(response);
                }).catch(error => {
                    this.loading = false;
                    reject(error);
                });
            });
        },
    },
});
